export default "__VITE_ASSET__BboZKlEU__"